<template>
  <font class="iconfont">&#xe72a;</font>
</template>

<script>
export default {
  name: "v-icon-arrow-right"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/v-icon-arrow-right.vue